import React from 'react';

const Step = ({ number, title, description }) => (
  <div className="flex gap-6 items-start">
    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 text-primary border border-primary/20 rounded-full flex items-center justify-center font-bold text-xl">
      {number}
    </div>
    <div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-textMuted leading-relaxed">{description}</p>
    </div>
  </div>
);

const HowItWorks = () => {
  return (
    <section className="py-20 px-4 border-t border-borderDark bg-cardBg/30">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">So einfach funktioniert's</h2>
          <p className="text-textMuted max-w-2xl mx-auto">In drei einfachen Schritten zu einem sicheren Browser-Erlebnis.</p>
        </div>

        <div className="space-y-12 max-w-2xl mx-auto">
          <Step
            number="1"
            title="Passwort einrichten"
            description="Legen Sie nach der Installation ein starkes Master-Passwort fest. Es wird lokal mit PBKDF2-SHA256 und 100.000 Iterationen gespeichert. Richten Sie außerdem drei Sicherheitsfragen ein."
          />
          <Step
            number="2"
            title="Sperren"
            description="Klicken Sie auf das Schloss-Symbol in Ihrer Toolbar oder warten Sie auf den Inaktivitäts-Timer, um alle offenen Tabs sofort zu verbergen und zu sichern."
          />
          <Step
            number="3"
            title="Sitzung wiederherstellen"
            description="Geben Sie Ihr Master-Passwort in den Sperrbildschirm ein. Ihre Tabs, Fenster und angehefteten Tabs werden wiederhergestellt."
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;